module.exports = __webpack_public_path__ + "img/zdcyl_bg.6dcca719.png";